//#region Angular Imports

import { StateService, StateProvider } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { SERVICES_MODULE_NAME } from './../../services'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { UserSession, ConfigHelper } from '../../helpers'

import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { ActorController, ActorScope } from './actors.controller'
import { ActorCreateEditDirective } from './create-edit/actors-create-edit.directive'
import { ActorDetailsDirective } from './details/actors-details.directive'

import { ActorHelper } from './actors.helper'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'

//#region Asset Imports

import * as TEMPLATE from './actors.tpl.html'

//#endregion

// Consts

const CONTROLLER_NAME: string = 'ActorController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'actorCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'actorDetails'
const MENU_INDEX = 10
const MODULE_NAME: string = 'simax.actors'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'ACTOR_NAME'
const STATE_NAME: string = 'actors'
const STATE_URL: string = '/actors'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: ActorScope,
        $state: StateService,
        $timeout,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService,
        systemService: SystemService
    ) => new ActorController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        userSession,
        systemService,
        ActorHelper.REFERENCE_TYPE,
        ActorHelper.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new ActorDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new ActorCreateEditDirective()])

module.config(["$stateProvider", 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {
    systemServiceProvider.registerDetailsComponent({
        key: 'Actor_IdActor',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.ACTOR_LIST)
                && !loggedOperator.hasPermission(Activity.ACTOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.ActorModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.CONTACTS),
                    'actors',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME